import React from 'react';
import './Footer.css'

const Footer = () => {
  return (
    <footer className="bg-dark text-light py-4">
      <div className="container fotter">
      <div className="row">
        <p style={{textAlign:"center",fontSize:10}}>Follow Us</p>
          <div className="col text-center">
            <ul className="list-unstyled list-inline social-links" style={{fontSize:30,color:"white"}}>
              <li className="list-inline-item">
                <a href="https://www.linkedin.com/company/lankatech-innovations" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-linkedin" ></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a href="https://www.facebook.com/lankatechinnovations" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook" ></i>
                </a>
              </li>
              {/* <li className="list-inline-item">
                <a href="https://www.github.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-github"></i>
                </a>
              </li> */}
              {/* <li className="list-inline-item">
                <a href="https://www.discord.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-discord" ></i>
                </a>
              </li> */}
              {/* <li className="list-inline-item">
                <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube" ></i>
                </a>
              </li> */}
              <li className="list-inline-item">
                <a href="https://wa.link/cgtij5" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-whatsapp" ></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="row fot_des" style={{marginTop:50}}>
          <div className="col-md-4">
            <h5 className='con'>Contact Us</h5>
            
            <p className='address'>
            <i class="fa-solid fa-house" style={{marginRight:10}}></i>
              {/* No 22/A Kurunduwatte,Kossinne <br></br>
              Gelioya.
              <br /> */}
              <i class="fa-solid fa-phone" style={{marginRight:10}}></i>
              +94(0) 76-293-8664
              <br></br>
              <i class="fa-solid fa-envelope" style={{marginRight:10}}></i>
              lankatechinnovations@gmail.com
            </p>
          </div>
          <div className="col-md-4">
            <h5 className='about'>About Us</h5>
            <p className='abo'>
            Lankatech Innovations is a dynamic tech company dedicated to delivering cutting-edge solutions. Based in Sri Lanka, our team specializes in software development, web design, and digital innovation. We're passionate about harnessing technology to empower businesses and individuals, driving progress in the digital world.
            </p>
          </div>
          <div className="col-md-4 faq" >
            <h5>FAQ</h5>
            <ul className="list-unstyled">
              <li>
                <a href="/faq">Frequently Asked Questions</a>
              </li>
              {/* Add more FAQ links as needed */}
            </ul>
          </div>
          
        </div>
        
        <div className="row" style={{marginTop:70,fontSize:12,color:"#a6a6a6"}}>
          <div className="col text-center">
            <p>&copy; 2023 LankaTech Innovations</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
